module.exports = __webpack_public_path__ + "static/media/testimonial_preview.53aaca0d.png";